import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import {
  withRouter,
  Switch,
  Route,
} from 'react-router-dom';

import NavigationBar from './components/NavigationBar/NavigationBar';

import Home from './containers/Home/Home';
import Login from './containers/Admin/Login';
import Materials from './containers/Materials/Materials';
import Mix from './containers/Mix/Mix';
import SettingsTabs from './containers/Settings/SettingsTabs';
import Discharge from './containers/Discharge/Discharge';
import PageLoading from './components/PageLoading/PageLoading';
import Notifier from './components/Notifier/Notifier';
import PlantChoice from './containers/Admin/PlantChoice/PlantChoice';
import Footer from './components/Footer/Footer';
import BatchForm from './containers/Batch/BatchForm';
import Tickets from './containers/Tickets/Tickets';
import { MaterialSubstitutionSidebar } from './components/MaterialSubstitution';
import {
  isModuleVisible,
  Modules,
} from './utils/module-controller';
import { Beforeunload } from 'react-beforeunload';
import PageError from './components/PageError/PageError';
import BannerDisplay from './modules/conditionalBanner/components/BannerDisplay/BannerDisplay';
import { ConditionalBannerManager } from './modules/conditionalBanner/managers/ConditionalBannerManager';
import { StartupPage } from './components/StartupPage/StartupPage';
import { isFeatureEnabled } from './utils/feature-flags';
import logger from './utils/logger';

const FEATURE_SHOW_STARTUP_PAGE = isFeatureEnabled('show_startup_page');

@inject('newAuthStore', 'settingsStore', 'locationsStore')
@observer
class App extends Component {
  componentDidMount() {
    window.addEventListener('wheel', this.handleWheel, { passive: false });
  }

  componentWillUnmount() {
    window.removeEventListener('wheel', this.handleWheel);
  }

  handleWheel = (e) => {
    const active = document.activeElement;

    if (active && active.type === 'number') {
      active.blur(); //blurs the input to stop scroll changes
      e.preventDefault();
    }
  };

  state = {
    startupComplete: false,
  };

  get isProduction() {
    return process.env.NODE_ENV === 'production';
  }

  handleStartupComplete = () => {
    this.setState({ startupComplete: true });
    logger.info(JSON.stringify(process.env, null, 2));
  };

  render() {
    const {
      location,
      newAuthStore,
      locationsStore,
      settingsStore,
    } = this.props;
    const { startupComplete } = this.state;

    if (!startupComplete && !newAuthStore.isAuthenticated && FEATURE_SHOW_STARTUP_PAGE) {
      return (
        <StartupPage onProceed={this.handleStartupComplete} />
      );
    }

    if (newAuthStore.authenticationError) {
      return (
        <PageError
          errorDetails={newAuthStore.authenticationError}
        >
          <h1>Authentication error</h1>
          <p>
            There was an error while trying to authenticate you. Please try again later.
            If the problem persists, please contact us.
          </p>
        </PageError>
      );
    }

    if (newAuthStore.isLoading || locationsStore.loadingLocations) {
      return <PageLoading/>;
    }

    if (!newAuthStore.isAuthenticated) {
      return <Login/>;
    }

    if (!locationsStore.plantId || !locationsStore.locationId || !locationsStore.plantChoiceFormSubmitted) {
      return <PlantChoice/>;
    }

    if (!locationsStore.divisionCode || !settingsStore.configuration || !settingsStore.configuration.ianaTimeZone
      || !settingsStore.notificationSettings) {
      return <PageLoading/>;
    }

    return (
      <div className="page-wrapper">
        <ConditionalBannerManager />
        {this.isProduction &&
          <Beforeunload onBeforeunload={() => 'Are you sure you want to close the application?'} />
        }
        <NavigationBar location={location} />
        <BannerDisplay />
        <main className="page-container">
          <div className="page-content-wrapper">
            <Switch>
              {isModuleVisible(Modules.MATERIALS) &&
                <Route exact path={'/materials'} component={Materials}/>
              }
              {isModuleVisible(Modules.MIXES) &&
                <Route exact path={'/mixes'} component={Mix}/>
              }
              {isModuleVisible(Modules.TICKETS) &&
                <Route exact path={'/tickets'} component={Tickets}/>
              }
              {isModuleVisible(Modules.TICKETS) &&
                <Route exact path={'/tickets/:id'} component={Tickets}/>
              }
              {isModuleVisible(Modules.SETTINGS) &&
                <Route exact path={'/settings'} component={SettingsTabs}/>
              }
              {isModuleVisible(Modules.DISCHARGE) &&
                <Route exact path={'/discharge'} component={Discharge}/>
              }
              <Route component={Home} />
            </Switch>
          </div>
        </main>
        <Footer location={location} />
        <BatchForm location={location} />
        <MaterialSubstitutionSidebar />
        <Notifier/>
      </div>
    );
  }
}

export default withRouter(App);
